<template>
  <div class="num-display">
    <span class="condition-name">{{ condition.name }}</span>
    <span class="compare-method">{{ condition.defaultVal.compareMethod }}</span>
    <el-input
      type="number"
      v-model="numQuery.item"
      :class="{ 'required-hint': !result }"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "numDisplay",
  props: {
    condition: Object
  },
  data() {
    return {
      numQuery: {
        item: null
      },
      result: true
    }
  },
  watch: {
    condition: {
      handler() {
        this.initData()
      },
      deep: true,
      immediate: true
    },
    numQuery: {
      handler() {
        this.$emit("getVerifyResult")
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initData() {
      this.numQuery.item = this.condition.defaultVal?.value
    },
    getNumFilters(chart) {
      if (this.numQuery.item) {
        let filter = {}
        filter.compareMethod = this.condition.defaultVal?.compareMethod
        filter.key = chart.controlId
        filter.type = this.condition.type
        filter.value = null
        filter.varItems = [{ value: this.numQuery.item, var: false }]
        return [filter]
      } else {
        return []
      }
    },
    getVerify() {
      let result = true
      if (this._.isEmpty(this.numQuery.item)) result = false
      this.result = result
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.num-display {
  display: flex;
  align-items: center;
  .condition-name {
    margin-right: 10px;
    white-space: nowrap;
  }
  .compare-method {
    margin-right: 10px;
    white-space: nowrap;
    width: unset;
  }
  .required-hint {
    ::v-deep {
      .el-input__inner {
        border-color: #f56c6c;
      }
      .container {
        border-color: #f56c6c;
      }
    }
  }
}
</style>
